import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NoiseSearchComponent } from './noise-search/noise-search.component';
import { SearchGroupComponent } from './search-group/search-group.component';
import { MicroenvSearchComponent } from './microenv-search/microenv-search.component';



@NgModule({
  declarations: [NoiseSearchComponent, SearchGroupComponent, MicroenvSearchComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    NzDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [NoiseSearchComponent, SearchGroupComponent, MicroenvSearchComponent]
})
export class SearchModule { }
